import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/wendu',
        name: 'wendu',
        component: LayoutNoFooter,
        children: [
            {
                path: 'activity',
                name: 'wendu-activity',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/wendu/activity'),
                props: route => ({
                }),
                meta: {
                    title: '活动风采',
                    isAuth: false,
                }
            },
            {
                path: 'activity/detail',
                name: 'wendu-activity-detail',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/wendu/activityDetail'),
                props: route => ({
                }),
                meta: {
                    title: '文章详情',
                    isAuth: false,
                }
            },
            {
                path: 'star',
                name: 'wendu-star',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/wendu/star'),
                props: route => ({
                }),
                meta: {
                    title: '督学之星',
                    isAuth: false,
                }
            },
            {
                path: 'star/detail',
                name: 'wendu-star-detail',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/wendu/starDetail'),
                props: route => ({
                }),
                meta: {
                    title: '文章详情',
                    isAuth: false,
                }
            }
        ]
    },
]
